import API from '../api/Http'
import * as EndPoints from '../api/EndPoints'
import { message } from 'antd'
import { RESPONSE_MESSAGE } from '../utils/constants'

const FETCH_REQUEST = 'customerTag/FETCH_REQUEST'
const FETCH_SUCCESS = 'customerTag/FETCH_SUCCESS'
const FETCH_FAILURE = 'customerTag/FETCH_FAILURE'

const MUTATE_REQUEST = 'customerTag/MUTATE_REQUEST'
const MUTATE_SUCCESS = 'customerTag/MUTATE_SUCCESS'
const MUTATE_FAILURE = 'customerTag/MUTATE_FAILURE'

const initialState = {
  isLoading: true,
  error: {},
  globalTagList: []
}

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_REQUEST:
    case MUTATE_REQUEST:
      return { ...state, isLoading: true }
    case FETCH_SUCCESS:
      return { ...state, isLoading: false, globalTagList: action.payload }
    case MUTATE_SUCCESS:
      return { ...state, isLoading: false }
    case FETCH_FAILURE:
    case MUTATE_FAILURE:
      return { ...state, isLoading: false, error: action.error }
    default:
      return state
  }
}

const showBackendError = (error) => {
  const backendMessage =
    error.response && error.response.data && error.response.data.message
  message.error(backendMessage || RESPONSE_MESSAGE.FAIL)
}

export const getGlobalTagList = () => {
  return async (dispatch) => {
    try {
      dispatch({ type: FETCH_REQUEST })
      const response = await API.get(EndPoints.CUSTOMER_TAG_GLOBAL)
      dispatch({ type: FETCH_SUCCESS, payload: response.data })
    } catch (error) {
      showBackendError(error)
      dispatch({ type: FETCH_FAILURE })
    }
  }
}

export const createGlobalTag = (data) => {
  return async (dispatch) => {
    try {
      dispatch({ type: MUTATE_REQUEST })
      await API.post(EndPoints.CUSTOMER_TAG_GLOBAL, data)
      dispatch({ type: MUTATE_SUCCESS })
      return true
    } catch (error) {
      showBackendError(error)
      dispatch({ type: MUTATE_FAILURE })
      return false
    }
  }
}

export const updateGlobalTag = (id, data) => {
  return async (dispatch) => {
    try {
      dispatch({ type: MUTATE_REQUEST })
      await API.put(`${EndPoints.CUSTOMER_TAG_GLOBAL}/${id}`, data)
      dispatch({ type: MUTATE_SUCCESS })
      return true
    } catch (error) {
      showBackendError(error)
      dispatch({ type: MUTATE_FAILURE })
      return false
    }
  }
}

export const deleteGlobalTag = (id) => {
  return async (dispatch) => {
    try {
      dispatch({ type: MUTATE_REQUEST })
      await API.delete(`${EndPoints.CUSTOMER_TAG_GLOBAL}/${id}`)
      dispatch({ type: MUTATE_SUCCESS })
      return true
    } catch (error) {
      showBackendError(error)
      dispatch({ type: MUTATE_FAILURE })
      return false
    }
  }
}

/**
 * ยุบป้ายกำกับของร้านที่ชื่อตรงกันเข้าเป็นป้ายกำกับกลางอันนี้
 *
 * ใช้ตอนออกป้ายกลางใหม่ที่ร้านหลายร้านสร้างชื่อเดียวกันไว้ก่อนแล้ว
 * mapping ถูกย้ายมาชี้ป้ายกลาง ป้ายของร้านถูกลบ และโควตาคืนให้ร้านเอง (spec E-3)
 */
export const mergeGlobalTag = (id) => {
  return async (dispatch) => {
    try {
      dispatch({ type: MUTATE_REQUEST })
      const response = await API.post(
        `${EndPoints.CUSTOMER_TAG_GLOBAL}/${id}/merge`
      )
      dispatch({ type: MUTATE_SUCCESS })
      return response.data
    } catch (error) {
      showBackendError(error)
      dispatch({ type: MUTATE_FAILURE })
      return null
    }
  }
}
